export default __webpack_public_path__ + "static/banner-christmas-gift-ideas-91780d86b6051afc5d13152d9b682bbc.jpg";